import { render } from "./PaymentMethodForm.vue?vue&type=template&id=98704202&scoped=true"
import script from "./PaymentMethodForm.vue?vue&type=script&lang=js"
export * from "./PaymentMethodForm.vue?vue&type=script&lang=js"

import "./PaymentMethodForm.vue?vue&type=style&index=0&id=98704202&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98704202"

export default script